/* eslint-disable no-console */

import { useEffect, useState, Dispatch, SetStateAction } from 'react';
import { Modal } from '@zeeve-platform/modal-component';
import axios from 'axios';
import TokenManager from '@zeeve-platform/login-utility';
import stopicon from '../../../assets/stop.png';
import sync from '../../../assets/sync.png';
import chart from '../../../assets/chart.png';
import lock from '../../../assets/lock.png';
import infocircle from '../../../assets/info-circle.png';
import deleteicon from '../../../assets/delete.png';
import cloud1 from '../../../assets/cloud-select-1.png';
import cloud2 from '../../../assets/cloud-select-0.png';
import cloud3 from '../../../assets/cloud-select-2.png';
import cloud4 from '../../../assets/cloud-select-4.png';
import cloud5 from '../../../assets/cloud-select-5.svg';
import zeeveCloud from '../../../assets/cloud-zeeve.svg';
import runningicon from '../../../assets/notifications-green.png';
import googlecloud from '../../../assets/cloud-select-3.png';
import pendingIcon from '../../../assets/notifications-time.png';
import { RpcDetailType } from '../../../types/network';
import { getBlockHeight as getBlockHeightData } from '../../../services/network';
import { deleteNode as deleteTheNode, getRpcDetails as getRpcDetailData } from '../../../services/node';
import Urls from '../../../utils/baseUrls';
import Loading from '../../../components/Loader';
import { axiosBackendInstance } from '../../../utils/axios';

const getCloudImage = (managed: boolean, str: string | number) => {
    if (managed) return zeeveCloud;
    switch (str.toString().toLowerCase()) {
        case '2051b7e0-0210-47e9-870f-76162f49ebf9':
            return cloud2;
        case '6cd1b682-bfe7-414c-9e4c-8ab8f8b20ac6':
            return cloud1;
        case '8691db48-8595-4eb9-9c2a-7bab535d9475':
            return cloud3;
        case 'fa02e4b7-118d-4163-8b15-26f5d18a6820':
            return cloud4;
        case 'c4ba9fa8-8fc3-4005-a837-6fa34df26ab7':
            return googlecloud;
        case '2ca3821c-864e-4a11-8280-6326db48f28c':
            return cloud5;

        default:
            return cloud2;
    }
};

interface Props {
    cloudimage: string;
    endpoint: string;
    region: string;
    node: string | number;
    state: string;
    networkId: string | number;
    setRpcDetail: (x: RpcDetailType) => void;
    setFlag: (x: boolean) => void;
    redirection_url: string;
    networkPayment: boolean;
    setNodeId: (x: string) => void;
    nodeID: string;
    nodeName: string;
    managedHosting: boolean;
    setCodes: Dispatch<SetStateAction<any>>;
}
interface RegionBody {
    id: string | number;
    region: string;
    region_name: string;
}
const LandingCard = ({
    cloudimage,
    region,
    node,
    state,
    endpoint,
    networkId,
    setRpcDetail,
    setFlag,
    redirection_url,
    networkPayment,
    setNodeId,
    nodeID,
    nodeName,
    setCodes,
    managedHosting,
}: Props) => {
    const [inActiveBtn, setInActiveBtn] = useState<boolean>(false);
    const [regions, setRegion] = useState([] as RegionBody[]);
    const [modalShow, setModalShow] = useState<boolean>(false);
    const [deleteNodeMsg, setDeleteNodeMsg] = useState<string>('');
    const [showLoader, setShowLoader] = useState<boolean>(false);
    const [deleteNodeBtn, setDeleteNode] = useState<boolean>(false);
    const [analyticsUrls, setAnalyticsUrls] = useState<{ dashboardName: string; dashboardURL: string }[]>([]);

    const loadRegions = () => {
        axiosBackendInstance
            .get(Urls.getCloudRegion(cloudimage), {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            })
            .then((response) => {
                if (response && response.data && response.data.data) {
                    setRegion(response.data.data);
                }
            })
            .catch(() => {
                setRegion([]);
                console.error('error getting regions');
            });
    };
    const getRegionName = (id: string | number) => {
        for (let i = 0; i < regions.length; i += 1) {
            if (regions[i].id === id.toString()) {
                return `${regions[i].region} (${regions[i].region_name})`;
            }
        }
        return 'none';
    };

    const getNodeAnalyticsUrls = async () => {
        try {
            const token = TokenManager.getInstance().getAccessToken();
            const analyticsDashboardURLsResponse = await axios.get(`/analytics/api/dashboard-urls?nodeID=${node}`, {
                headers: {
                    authorization: `Bearer ${token}`,
                },
            });

            if (analyticsDashboardURLsResponse && analyticsDashboardURLsResponse.data) {
                setAnalyticsUrls(analyticsDashboardURLsResponse.data);
            }
        } catch (error) {
            setAnalyticsUrls([]);
        }
    };

    useEffect(() => {
        loadRegions();
        if (state && (state.toLowerCase() === 'provisioning' || state.toLowerCase() === 'ready')) {
            getNodeAnalyticsUrls();
        }
    }, []);

    const showAnalyticsMessage = () => {
        const div2 = document.getElementById('analyticsDiv');
        if (div2) div2.style.display = 'block';
        setTimeout(() => {
            if (div2) div2.style.display = 'none';
        }, 1000);
    };

    const setText = async (id: number | string, val: string) => {
        setShowLoader(true);
        const response: any = await getRpcDetailData(networkId.toString(), id.toString());
        // const response: any = await (
        // await axios.get(`http://localhost:3001/networks/${networkId}/nodes/${id.toString()}`)
        // ).data;
        setShowLoader(false);
        if (response) {
            if (response && response.success) {
                setRpcDetail(response.data);
                // getBlockHeight(id.toString());
                setNodeId(id.toString());
                setFlag(true);
                // const urlTag = document.getElementById('url-tag');
                const httpPtag = document.getElementById('http-ptag');
                const webPtag = document.getElementById('web-tag');
                let httpUrl: URL | undefined;
                let wsUrl: URL | undefined;
                if (httpPtag && webPtag) {
                    // urlTag.innerHTML = `const url = "https://${response.data.rpcUsername}:****@${val}" ;`;
                    if (response.data.http) {
                        httpPtag.innerHTML = `https://${response.data.rpcUsername}:****@${val}/`;
                    } else {
                        httpPtag.innerHTML = 'HTTP is disabled';
                    }
                    if (response.data.ws) {
                        webPtag.innerHTML = `wss://${response.data.rpcUsername}:****@${val}/websocket/`;
                    } else {
                        webPtag.innerHTML = 'WSS is disabled';
                    }
                }

                if (response.data.http) {
                    httpUrl = new URL(
                        `https://${response.data.rpcUsername}:****@${val}/cosmos/base/tendermint/v1beta1/node_info`,
                    );
                } else {
                    httpUrl = undefined;
                }

                if (response.data.ws) {
                    wsUrl = new URL(`wss://${response.data.rpcUsername}:****@${val}/websocket`);
                } else {
                    wsUrl = undefined;
                }

                if (setCodes) {
                    setCodes(() => [
                        {
                            lang: 'CURL',
                            http:
                                httpUrl &&
                                `
curl ${httpUrl.href} -X GET -H 'Content-Type:application/json'`,
                        },
                        {
                            lang: 'WSCAT',
                            wss:
                                wsUrl &&
                                `
npx wscat -c ${wsUrl.href}`,
                        },
                        {
                            lang: 'NodeJs',
                            http:
                                httpUrl &&
                                `
import axios from "axios";
                   
const config = {
  method: 'get',
  url: '${httpUrl.href}',
  headers: { 
    'Content-Type': 'application/json'
  },
};
                    
axios(config)
.then(function (response) {
  console.log(JSON.stringify(response.data));
})
.catch(function (error) {
    console.log(error);
});`,
                            wss:
                                wsUrl &&
                                `
import WebSocket from 'ws';

const ws = new WebSocket('${wsUrl.href}');
                    
ws.on('open', function open() {
        console.log('connected');
                    
// NOTE : use delay to avoid missing messages from server
setTimeout(() => {
    const msg = {"jsonrpc":"2.0","method":"status","id":1};
    ws.send(JSON.stringify(msg));
    }, 1000);
});
                    
ws.on('message', function message(data) {
  console.log('received: %s', data);
});`,
                        },
                        {
                            lang: 'Python',
                            http:
                                httpUrl &&
                                `
import requests

url = '${httpUrl.href}'  

x = requests.get(url)

print(x.text)`,
                            wss:
                                wsUrl &&
                                `
import asyncio
from websockets import connect
import time
import json

async def hello(uri):
        async with connect(uri) as websocket:
                print('connected')
                time.sleep(1)
                await websocket.send(json.dumps({"jsonrpc":"2.0","method":"status","id":1}))
                message = await websocket.recv()
                print(message)

asyncio.run(hello("${wsUrl.href}"))`,
                        },
                        {
                            lang: 'Go',
                            http:
                                httpUrl &&
                                `
package main

import (
    "fmt"
    "io/ioutil"
    "log"
    "net/http"
)
                        
func main() {

    resp, err := http.Get("${httpUrl.href}")


    if err != nil {
        log.Fatalf("HTTP request error: %v", err)
    }
    defer resp.Body.Close()

    body, err := ioutil.ReadAll(resp.Body)
    if err != nil {
        log.Fatalf("ReadAll error: %v", err)
    }

    fmt.Println(string(body))
}`,
                            wss:
                                wsUrl &&
                                `
package main

import (
    "encoding/base64"
    "log"
    "net/http"
    "os"
    "os/signal"
    "time"

    "github.com/gorilla/websocket"
)

func main() {
    addr := "${wsUrl.href}"
    username := "${response.data.rpcUsername}"
    password := "****"
    headers := http.Header{
        "Authorization": {"Basic " + base64.StdEncoding.EncodeToString([]byte(username+":"+password))},
    }

    interrupt := make(chan os.Signal, 1)
    signal.Notify(interrupt, os.Interrupt)

    log.Printf("connecting to %s", addr)
    c, _, err := websocket.DefaultDialer.Dial(addr, headers)
    if err != nil {
        log.Fatal("dial error:", err)
    }
    defer c.Close()

    done := make(chan struct{})
    go func() {
        defer close(done)
        for j := 1; j <= 1; j++ {
            _, message, err := c.ReadMessage()
            if err != nil {
                log.Println("read error:", err)
                return
            }
            log.Printf("received: %s", message)
        }
    }()
    ticker := time.NewTicker(time.Second)
    defer ticker.Stop()
    for {
        select {
        case <-done:
            log.Println("done")
            return
        case <-ticker.C:
            data := \`{ "jsonrpc": "2.0", "id": 1, "method": "status" }\`
            err = c.WriteMessage(websocket.TextMessage, []byte(data))
            if err != nil {
                log.Println("write error:", err)
                return
            }
            log.Printf("sent: %s", data)
        case <-interrupt:
            log.Println("interrupt")
            err := c.WriteMessage(websocket.CloseMessage, websocket.FormatCloseMessage(websocket.CloseNormalClosure, ""))
            if err != nil {
                log.Println("write close:", err)
                return
            }
            select {
            case <-done:
            case <-time.After(time.Second):
            }
            return
        }
    }
}`,
                        },
                    ]);
                }
            }
        } else {
            showRpcMessage();
            setFlag(false);
        }
    };

    const getBlockHeight = async (nodeId: string) => {
        const blockHeightTag = document.getElementById('blockHeight');
        const response: any = await getBlockHeightData(networkId.toString(), nodeId.toString());
        if (response && response.success) {
            if (blockHeightTag) {
                blockHeightTag.innerHTML = response.data.blockHeight;
            }
        }
    };

    const deleteNode = async () => {
        setInActiveBtn(true);
        setShowLoader(true);
        const response: any = await deleteTheNode(networkId.toString(), nodeID.toString());
        setShowLoader(false);
        if (response) {
            if (response.success) {
                setInActiveBtn(false);
                setDeleteNode(false);
                setDeleteNodeMsg(response.data.message);
                setTimeout(() => {
                    window.location.reload();
                }, 5000);
            } else if (response.error) {
                setInActiveBtn(false);
                setDeleteNode(false);
                setDeleteNodeMsg('Error deleting node');
                if (response.error.message) setDeleteNodeMsg(response.error.message);
                if (response.error.reason) setDeleteNodeMsg(response.error.reason);
                if (response.error.details) setDeleteNodeMsg(response.error.details);
            }
        } else {
            setDeleteNodeMsg('Error deleting node');
            setInActiveBtn(false);
            setDeleteNode(false);
        }
    };
    const clickedDeleteIcon = (nodeId: string | number) => {
        setNodeId(nodeId.toString());
        setModalShow(true);
        setDeleteNode(true);
    };

    const confirmDeleteNode = () => {
        deleteNode();
    };

    const showRpcMessage = () => {
        const div2 = document.getElementById('rpcFail2');
        if (div2) div2.style.display = 'block';
        setTimeout(() => {
            if (div2) div2.style.display = 'none';
        }, 1000);
    };
    const showMessage = () => {
        const div2 = document.getElementById('fail');
        if (div2) div2.style.display = 'block';
        setTimeout(() => {
            if (div2) div2.style.display = 'none';
        }, 1000);
    };
    const hideModal = () => {
        setDeleteNodeMsg('');
        setModalShow(false);
    };
    return (
        <div className='mt-4 d-flex text-center ' style={{ textAlign: 'center', justifyContent: 'center' }}>
            <div className='col-3 p-1 mt-1 border-end'>
                <img src={getCloudImage(managedHosting, cloudimage)} height='25px' width='25px' alt='' />
                <p className='node-font mt-1 mb-0' title={node.toString()}>
                    {nodeName}
                </p>
            </div>
            <div className='col-4 p-2 border-end'>
                <p className='mb-0'>{getRegionName(region)}</p>
                <a
                    href='#display'
                    className='btn mt-1'
                    onClick={() => {
                        setText(node, endpoint);
                    }}
                    style={{
                        border: '#4D88F7 solid 2px',
                        color: '#3E7EF5',
                        fontSize: '12px',
                    }}
                >
                    View Endpoint
                </a>
            </div>
            {networkPayment && (
                <div className='mt-2 pt-3 col-6'>
                    <h6>Network Payment Pending</h6>
                </div>
            )}
            {!networkPayment && state === 'payment_pending' && (
                <div className='mt-2 pt-3 col-6'>
                    <a href={redirection_url} className='btn btn-primary text-decoration-none'>
                        Pay Now
                    </a>
                </div>
            )}
            {/* {!networkPayment && state !== 'payment_pending' && (
                <div className='mt-3 p-1 col-3 border-end'>
                    {state !== 'ready' && (
                        <li className='btnNodeli'>
                            <img className='btnNode' title='locked' src={lock} height='22px' alt='' />
                        </li>
                    )}
                    {state === 'ready' && (
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            <li
                                className='btnNodeli mx-1'
                                aria-hidden
                                title='stop'
                                onClick={() => {
                                    showMessage();
                                }}
                            >
                                <img className='btnNode' src={stopicon} height='22px' alt='' />
                            </li>
                            <li
                                className='btnNodeli'
                                aria-hidden
                                title='restart'
                                onClick={() => {
                                    showMessage();
                                }}
                            >
                                <img className='btnNode' src={sync} height='22px' alt='' />
                            </li>
                        </div>
                    )}
                </div>
            )} */}
            {!networkPayment && state !== 'payment_pending' && (
                <div className='mt-3 p-1 col-3'>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <li className='btnNodeli'>
                            <div className='btn-group btnNodeli'>
                                <img
                                    className='btnNode dropdown-toggle'
                                    src={chart}
                                    height='22px'
                                    alt=''
                                    id={`${node}dropdownMenuButton2`}
                                    data-toggle='dropdown'
                                    data-bs-toggle='dropdown'
                                    aria-expanded='false'
                                />
                                <div className='dropdown-menu' aria-labelledby='dropdownMenuButton2'>
                                    {analyticsUrls && analyticsUrls.length > 0 ? (
                                        analyticsUrls.map((item) => (
                                            <a
                                                className='dropdown-item'
                                                href={item.dashboardURL}
                                                key={item.dashboardName}
                                                target='_blank'
                                                rel='noreferrer'
                                            >
                                                {item.dashboardName}
                                            </a>
                                        ))
                                    ) : (
                                        <button
                                            type='button'
                                            className='dropdown-item'
                                            onClick={() => {
                                                showAnalyticsMessage();
                                            }}
                                        >
                                            Analytics Not Ready
                                        </button>
                                    )}
                                </div>
                            </div>
                        </li>
                        {state !== 'requested' && (
                            <li
                                className='btnNodeli'
                                aria-hidden
                                onClick={() => {
                                    clickedDeleteIcon(node);
                                }}
                            >
                                <img className='btnNode mx-1' src={deleteicon} height='22px' alt='' />
                            </li>
                        )}
                        {state === 'ready' && (
                            <img src={runningicon} style={{ height: '22px' }} title='Running' alt='' />
                        )}
                        {state === 'provisioning' && (
                            <img src={pendingIcon} style={{ height: '22px' }} title='Pending' alt='' />
                        )}
                        {state !== 'ready' && state !== 'provisioning' && (
                            <img src={infocircle} style={{ height: '22px' }} title='Stop' alt='' />
                        )}
                    </div>
                </div>
            )}
            {showLoader && <Loading />}
            <Modal
                show={modalShow}
                onHide={() => hideModal()}
                title='Are you sure you want to delete Node?'
                visibleFooter
                visibleFooterCloseButton
                visibleHeaderCloseIcon={false}
                visibleConfirmBtn={deleteNodeBtn}
                confirmBtnText='Yes'
                onConfirm={confirmDeleteNode}
                confirmBtnClassName=''
            >
                <p className='status text-center pt-3'>{deleteNodeMsg}</p>
            </Modal>
        </div>
    );
};

export default LandingCard;
